<div class="mtlr-3" style="display:flex;flex-direction: column;">
    <div>
        <app-meddra-toolbox [selectedNode]="selectedNode"
            (buttonAction)="onButtonAction($event)"></app-meddra-toolbox>
    </div>

    <div *ngIf="this.loading&&!isQueryListView()" style="padding-top: 300px;">
        <app-loading />
    </div>

    <div class="scroll-container" *ngIf="selectedNode" [attr.style]="this.loading? 'height: 0px;' : 'height: calc(100vh - 235px);'">
        <div *ngIf="isInstanceOfFormlyView()&&!this.loading">
            <app-formly-detailed-view #formly_detailed_view_component
                [selectedNode]="selectedNode"></app-formly-detailed-view>
        </div>

        <div *ngIf="isInstanceOfListView() && (!isQueryListView())">
            <app-list-detailed-view [selectedNode]="selectedNode" (buttonAction)="onButtonAction($event)"
                (selectedNodeChange)="onSelectedNodeChange($event)"
                (removeNode)="onRemoveNode($event)"></app-list-detailed-view>
        </div>

        <div *ngIf="isQueryListView()">
            <app-item-finder #item_finder_component [selectedNode]="selectedNode"
                (selectedNodeChange)="onSelectedNodeChange($event)"
                (doAction)="onButtonAction($event)"></app-item-finder>
        </div>
    </div>



</div>